/**
 * @generated SignedSource<<bdec4ccd965e7ce220f4951f14c0f363>>
 * @relayHash 2a81d25c101fe76ba857af1c025d4b9f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 264a08fb119eb0131f885e394dcd716a8f97fa195884d7e69fe9fa5c471aaa1c

import type { ConcreteRequest } from 'relay-runtime';
export type DisableSuperAdminMutationComponentMutation$variables = Record<PropertyKey, never>;
export type DisableSuperAdminMutationComponentMutation$data = {
  readonly disableSuperAdmin: {
    readonly user: {
      readonly confluence: {
        readonly roles: {
          readonly isSuperAdmin: boolean;
        } | null | undefined;
      } | null | undefined;
      readonly id: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type DisableSuperAdminMutationComponentMutation = {
  response: DisableSuperAdminMutationComponentMutation$data;
  variables: DisableSuperAdminMutationComponentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "concreteType": "ConfluenceUser",
      "kind": "LinkedField",
      "name": "confluence",
      "plural": false,
      "selections": [
        {
          "concreteType": "GraphQLConfluenceUserRoles",
          "kind": "LinkedField",
          "name": "roles",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isSuperAdmin"
            }
          ]
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "DisableSuperAdminMutationComponentMutation",
    "selections": [
      {
        "concreteType": "SuperAdminPayload",
        "kind": "LinkedField",
        "name": "disableSuperAdmin",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DisableSuperAdminMutationComponentMutation",
    "selections": [
      {
        "concreteType": "SuperAdminPayload",
        "kind": "LinkedField",
        "name": "disableSuperAdmin",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v0/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "2a81d25c101fe76ba857af1c025d4b9f",
    "id": "264a08fb119eb0131f885e394dcd716a8f97fa195884d7e69fe9fa5c471aaa1c",
    "metadata": {},
    "name": "DisableSuperAdminMutationComponentMutation",
    "operationKind": "mutation",
    "text": "mutation DisableSuperAdminMutationComponentMutation{disableSuperAdmin{user{id,confluence{roles{isSuperAdmin}}},id}}"
  }
};
})();

(node as any).hash = "5f3ba0ec2f60fe58588e37cc5bf3cb97";

export default node;
